var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.214.5c.79 0 1.429.559 1.429 1.25V3h5.714V1.75c0-.691.639-1.25 1.429-1.25s1.428.559 1.428 1.25V3h2.143c1.183 0 2.143.84 2.143 1.875V6.75H.5V4.875C.5 3.84 1.46 3 2.643 3h2.143V1.75c0-.691.638-1.25 1.428-1.25zM.5 8h20v10.625c0 1.035-.96 1.875-2.143 1.875H2.643C1.46 20.5.5 19.66.5 18.625V8zm2.857 3.125v1.25c0 .344.322.625.714.625H5.5c.393 0 .714-.281.714-.625v-1.25c0-.344-.321-.625-.714-.625H4.071c-.392 0-.714.281-.714.625zm5.714 0v1.25c0 .344.322.625.715.625h1.428c.393 0 .715-.281.715-.625v-1.25c0-.344-.322-.625-.715-.625H9.786c-.393 0-.715.281-.715.625zM15.5 10.5c-.393 0-.714.281-.714.625v1.25c0 .344.321.625.714.625h1.429c.392 0 .714-.281.714-.625v-1.25c0-.344-.322-.625-.714-.625H15.5zM3.357 16.125v1.25c0 .344.322.625.714.625H5.5c.393 0 .714-.281.714-.625v-1.25c0-.344-.321-.625-.714-.625H4.071c-.392 0-.714.281-.714.625zm6.429-.625c-.393 0-.715.281-.715.625v1.25c0 .344.322.625.715.625h1.428c.393 0 .715-.281.715-.625v-1.25c0-.344-.322-.625-.715-.625H9.786zm5 .625v1.25c0 .344.321.625.714.625h1.429c.392 0 .714-.281.714-.625v-1.25c0-.344-.322-.625-.714-.625H15.5c-.393 0-.714.281-.714.625z",
    fill: "#115E59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardCalender);
export default __webpack_public_path__ + "static/media/CardCalender.5437b1746913bc9a9dfbe68b80e29c04.svg";
export { ForwardRef as ReactComponent };